import type { WebpImageName } from '@/types/_webp'
import { getWebpUrl } from '@/utils/webpAssets'
import { VENUE_CODE, type VenueCode } from '@/config/venue'

export const VENUE_ICON_MAP: Record<VenueCode, WebpImageName> = {
  [VENUE_CODE.ISLOT]: 'imgs/sideMenu/icon-slotMachine.webp',
  [VENUE_CODE.LIVE]: 'imgs/sideMenu/icon-livecasino.webp',
  [VENUE_CODE.SLOT]: 'imgs/sideMenu/icon-slot.webp',
  [VENUE_CODE.SPORT]: 'imgs/sideMenu/icon-sport.webp',
  [VENUE_CODE.ESPORTS]: 'imgs/sideMenu/icon-esport.webp',
  [VENUE_CODE.MINI]: 'imgs/sideMenu/icon-mini-gameds.webp',
  [VENUE_CODE.FISH]: 'imgs/sideMenu/icon-fish.webp'
}

export const getVenueIconUrl = (code?: string): string => {
  const key = String(code ?? '').toUpperCase() as VenueCode
  const name = VENUE_ICON_MAP[key]
  return name ? getWebpUrl(name) : ''
}
